// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorComponent_container__1wM2p","refreshBtn":"ErrorComponent_refreshBtn__1Fu2_"};